{
  "id": "league-global-01",
  "name": "Liga Global de Mánagers",
  "description": "Competición oficial global contra directores técnicos de todo el mundo. Ascensos, descensos y mercado dinámico semanal.",
  "type": "GLOBAL",
  "code": "GLOBAL",
  "season": "2026/27",
  "totalClubs": 20,
  "userClubId": "club-user",
  "userClubName": "Atlético Metropolitano",
  "userClubCode": "ATM",
  "userPosition": 3,
  "userPoints": 12,
  "currentMatchdayNumber": 5,
  "totalMatchdays": 38,
  "activeUsersCount": 18420,
  "badgeColor": "#10b981",
  "isCreator": false
}
